module.exports = __webpack_public_path__ + "img/stripe-network-tab.0cf31a84.png";